import React, { useState, useRef, useEffect } from 'react';
import { BsDownload, BsUpload } from 'react-icons/bs';
import CropImage from '../image-crop';
import Modal from '../modal';

interface UploadImageProps {
  onChange: (file: any) => void;
  label?: string;
  name: string;
  setFieldValue?: any;
  required?: any;
  cropAsp?: any;
  SetImageName?: any;
  btnLabel?: any;
}

const UploadImage: React.FC<UploadImageProps> = ({
  name,
  onChange,
  label,
  setFieldValue,
  required,
  cropAsp,
  SetImageName,
  btnLabel,
}) => {
  const [image, setImage] = useState<any>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<string>('');
  const fileRef = useRef<any>(null);

  const inputElement = document.querySelector<HTMLInputElement>(
    'input[name="image"]'
  );

  const handleModal = () => {
    setShowModal(!showModal);
    // setFieldValue && setFieldValue(name, null);
    setImage(null);
    if (inputElement) {
      inputElement.value = '';
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      // Check if the file size is within the limit (5MB)
      if (file.size > 5 * 1024 * 1024) {
        // Handle the case where the file exceeds the limit (e.g., show an alert)
        setUploadError(' File size exceeds the limit of 5MB');
        if (inputElement) {
          inputElement.value = '';
        }
        return;
      } else {
        SetImageName && SetImageName(file.name);
        setUploadError('');
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        setImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    image && setShowModal(true);
  }, [image]);

  return (
    <div className="mb-4">
      <label className="text-text-black font-normal text-md mb-2 block">
        {label}
      </label>
      {showModal ? (
        <>
          <Modal title={'Crop Image'} onClick={handleModal} hideCross={true}>
            <CropImage
              image={image}
              onChange={onChange}
              handleModal={handleModal}
              cropAsp={cropAsp}
            />
          </Modal>
        </>
      ) : (
        <>
          <div
            className="border-dashed border border-primary cursor-pointer rounded-xl p-5 space-x-3 flex items-center justify-center"
            onClick={() => {
              fileRef?.current?.click();
            }}
          >
            <BsUpload color="#4062FF" size={32} />
            <p className="text-black text-center text-sm font-semibold">
              {btnLabel || 'Upload Image'}
            </p>
          </div>
          {uploadError && <p className="text-warning text-sm">{uploadError}</p>}
        </>
      )}
      <input
        type="file"
        name={name}
        id=""
        hidden
        required={required}
        ref={fileRef}
        onChange={handleFileChange}
        accept="image/*"
      />
    </div>
  );
};

export default React.memo(UploadImage);
